<template>
  <div
    class="absolute left-0 z-[3000] flex h-screen w-full items-center justify-center overflow-hidden bg-black/50"
    :style="{
      top: topPos + 'px',
    }"
  >
    <slot v-if="isShow" />
  </div>
</template>
<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useBodyScrollLock } from 'xangle-ui/src/composables/useBodyScrollLock'
type IProps = {
  randomKey: string
}
defineProps<IProps>()
const { lockBodyScroll, initBodyScroll } = useBodyScrollLock()

const isShow = ref(false)
const topPos = ref(0)

onMounted(() => {
  isShow.value = true
  topPos.value = document.documentElement.scrollTop
  lockBodyScroll()
})

onBeforeUnmount(() => {
  initBodyScroll()
})
</script>


<style scoped lang="scss">

</style>